import React, { useEffect, useState } from 'react';

import LoadingAircraft from './LoadingAircraft';

interface Props {
  loading: boolean;
}

const LoginAnimation: React.FC<Props> = ({ loading }) => {
  const CSSBlock = 'loading-login';
  const CSSBlockJet = 'loading-jet';

  return (
    <div className={`${CSSBlock} ${loading ? `${CSSBlock}--loading` : ''}`}>
      <LoadingAircraft animated={loading} />
    </div>
  );
};

export default LoginAnimation;
